import React from 'react';
import PropTypes from 'prop-types';
import { Button, Spinner } from 'react-bootstrap';
import './LoaderButton.css';

function LoaderButton({
  isLoading = false,
  className = '',
  disabled = false,
  fullWidth = false,
  variant = "primary",
  ...props
}) {
  function getSpinner(isLoading) {
    if (isLoading) {
      return(
        <Spinner
          className="me-2"
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
        />
      );
    }
    return(null);
  }

  return(
    <Button
      block={fullWidth.toString()}
      className={`LoaderButton ${className}`}
      disabled={disabled || isLoading}
      variant={variant}
      {...props}
    >
      {getSpinner(isLoading)}
      {props.children}
    </Button>
  );
}

LoaderButton.propTypes = {
  /**
   * Whether the button should render as loading.
   */
  isLoading: PropTypes.bool,
  /**
   * Classname to set for the button element.
   */
  className: PropTypes.string,
  /**
   * Whether the button should be disabled. Defaults to false.
   */
  disabled: PropTypes.bool,
  /**
   * Whether to show the button as being the full width of the page.
   * (defaults to false)
   */
  fullWidth: PropTypes.bool,
  /**
   * Colour of the button.
   */
  variant: PropTypes.oneOf([
    "primary",
    "secondary",
    "success",
    "warning",
    "danger",
    "light",
    "link",
  ])
 }

export default LoaderButton;